<template>
  <div
    ref="root"
    class="scroll-reveal"
    :class="{
      'is-visible': visible,
      'scroll-reveal--stagger': stagger,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "ScrollReveal",
  props: {
    stagger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      this.visible = true;
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible = true;
          this.observer.disconnect();
        }
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    this.observer.observe(this.$refs.root);
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
